export enum FormFieldType {
  AccountNumber = 'account_number',
  AccountNumberQR = 'account_number_qr',
  IBAN = 'iban',
  Holder = 'holder',
  SwiftBic = 'swift_bic',
  Bic = 'bic',
  IMPSAccountNumber = 'imps_account_number',
  IFSCCode = 'ifsc',
  BeneficiaryName = 'beneficiary_name',
  Phone = 'phone',
  UPIId = 'upi_id',
  Card = 'card',
  Cardholder = 'cardholder',
  IdCard = 'id_card',
  ERIP = 'erip',
  ExpirationDate = 'expiration_date',
  AccountLastDigits = 'account_last_digits',
  TaxId = 'tax_id',
  PaymentLink = 'payment_link',
  PaymentString = 'payment_string',
  QRManagerAPIKey = 'qr_manager_api_key',
  QRManagerLogin = 'qr_manager_login',
}
